import { render, staticRenderFns } from "./Validacao.vue?vue&type=template&id=3ba06b8f&scoped=true"
import script from "./Validacao.vue?vue&type=script&lang=js"
export * from "./Validacao.vue?vue&type=script&lang=js"
import style0 from "./Validacao.vue?vue&type=style&index=0&id=3ba06b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba06b8f",
  null
  
)

export default component.exports